import 'core-js/modules/es.object.assign.js';
import { __rest } from '../../../_virtual/_tslib.js';
import { jsx } from 'react/jsx-runtime';
import { Chip, chipClasses, CircularProgress } from '@mui/material';
import { styled, css } from '@mui/material/styles';
import { alpha, spacing as spacing$1 } from '@mui/system';
import { switchProp } from 'styled-tools';
import { shouldNotForwardProps, shape, spacing, withUtility } from '../../foundation/utils.js';

let _ = t => t,
  _t,
  _t2,
  _t3,
  _t4,
  _t5,
  _t6,
  _t7,
  _t8,
  _t9,
  _t10,
  _t11;
const AssistChipStyled = styled(Chip, {
  shouldForwardProp: shouldNotForwardProps
})(_t || (_t = _`
  height: ${0};
  border-width: 1px;
  border-radius: ${0};
  font-size: 14px;
  gap: ${0};

  ${0}

  ${0};

  ${0};

  ${0};

  .${0} {
    margin: 0;
    padding: 0;
  }

  ${0};
`), switchProp('size', {
  small: '36px',
  medium: '40px'
}), shape('small'), spacing(2), withUtility(({}, {
  fullWidth
}) => {
  if (!fullWidth) {
    return;
  }
  return css(_t2 || (_t2 = _`
      width: 100%;
    `));
}), withUtility(({
  palette
}, {
  label,
  icon,
  size,
  loading,
  hierarchy
}) => {
  return css(_t3 || (_t3 = _`
      padding: ${0};
      padding-right: ${0};
      &:hover {
        cursor: pointer;
        ${0}
      }
      & .${0} {
        font-size: 20px;
      }
      & .${0} {
        display: ${0};
      }

      .${0} {
        margin: ${0};
      }
    `), spacing(size === 'small' ? 1 : 2, 2), spacing(icon ? 3 : 2), hierarchy !== 'secondary' && css(_t4 || (_t4 = _`
          & .MuiTouchRipple-root {
            background-color: ${0};
            opacity: 0.08;
          }
        `), palette('outline')), chipClasses.icon, chipClasses.label, label ? 'inline-block' : 'none', chipClasses.icon, loading ? spacing(1) : 0);
}), withUtility(({
  palette,
  isLight
}, {
  hierarchy
}) => {
  switch (hierarchy) {
    case 'positive':
      return css(_t5 || (_t5 = _`
          color: ${0};
          border-color: ${0};
          background-color: ${0};
          & .${0} {
            color: ${0};
          }
          &.${0}:hover {
            background-color: ${0};
          }
        `), palette('onPrimaryContainer'), palette('onPrimaryContainer'), palette('primaryContainer'), chipClasses.icon, palette('onPrimaryContainer'), chipClasses.clickable, palette('primaryContainer'));
    case 'negative':
      return css(_t6 || (_t6 = _`
          color: ${0};
          border-color: ${0};
          background-color: ${0};
          & .${0} {
            color: ${0};
          }
          &.${0}:hover {
            background-color: ${0};
          }
        `), palette('onErrorContainer'), palette('onErrorContainer'), palette('errorContainer'), chipClasses.icon, palette('onErrorContainer'), chipClasses.clickable, palette('errorContainer'));
    case 'secondary':
      return css(_t7 || (_t7 = _`
          color: ${0};
          border-color: ${0};
          background-color: ${0};
          &.${0} {
            opacity: 1;
            border: 1px solid;
            color: ${0};
            border-color: ${0};
            background: ${0};
          }
          &:hover {
            background: linear-gradient(
                0deg,
                ${0} 0%,
                ${0} 100%
              ),
              #fff;
          }
          & .${0} {
            color: ${0};
          }
          &.${0}:hover {
            background-color: ${0}
              #fff;
          }
          ${0}
        `), isLight ? palette('onSurfaceVariant') : palette('surfaceVariant'), palette('onSurface'), isLight ? palette('surface') : palette('onSurface'), chipClasses.disabled, isLight ? alpha(palette('onSurfaceVariant'), 0.38) : alpha(palette('onSurface'), 0.38), isLight ? alpha(palette('onSurfaceVariant'), 0.38) : alpha(palette('onSurface'), 0.38), isLight ? alpha(palette('onSurfaceVariant'), 0.08) : alpha(palette('onSurface'), 0.12), alpha(palette('onPrimary'), 0.08), alpha(palette('onPrimary'), 0.08), chipClasses.icon, palette('onSurfaceVariant'), chipClasses.clickable, isLight ? alpha(palette('onPrimaryContainer'), 0.08) : alpha(palette('onPrimary'), 0.12), isLight && css(_t8 || (_t8 = _`
            border: 1px solid ${0};
          `), palette('onSurfaceVariant')));
    default:
      return css(_t9 || (_t9 = _`
          color: ${0};
          border-color: ${0};
          & .${0} {
            color: ${0};
          }
        `), palette('onSurface'), palette('outline'), chipClasses.icon, palette('onSurfaceVariant'));
  }
}), withUtility(({
  palette
}, {
  variant
}) => {
  switch (variant) {
    case 'text':
      return css(_t10 || (_t10 = _`
          background-color: transparent;
          &:hover {
            background-color: ${0};
          }
          &:focus {
            background-color: ${0};
          }
        `), alpha(palette('onSurfaceVariant'), 0.08), alpha(palette('onSurfaceVariant'), 0.12));
    default:
      return css(_t11 || (_t11 = _``));
  }
}), chipClasses.label, spacing$1);
const AssistChip = _a => {
  var {
      variant = 'outlined',
      hierarchy = 'neutral',
      loading = false,
      label,
      icon,
      disabled,
      clickable = true
    } = _a,
    props = __rest(_a, ["variant", "hierarchy", "loading", "label", "icon", "disabled", "clickable"]);
  return jsx(AssistChipStyled, Object.assign({
    variant: variant,
    hierarchy: hierarchy,
    loading: loading,
    label: label,
    icon: loading ? jsx(CircularProgress, {
      size: 16
    }) : icon,
    disabled: loading ? loading : disabled,
    clickable: clickable
  }, props));
};

export { AssistChip, AssistChipStyled };
